import { Alert, Box, Button, Typography } from "@mui/material";
import React from "react";
import CustomTabs from "../../widgets/CustomTabs";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import PhoneForwardedIcon from "@mui/icons-material/PhoneForwarded";
import ContactPhoneIcon from "@mui/icons-material/ContactPhone";
import RdCampaignImport from "./contacts/RdCampaignImport";
import HighlightIcon from "@mui/icons-material/Highlight";
import RdCampaignContactGoup from "./contacts/RdCampaignContactGoup";
import RdCampaignQuickContacts from "./contacts/RdCampaignQuickContacts";
import RdMarketingGroup from "./contacts/RdMarketingGroup";
const RdCampaignStep2 = ({
  campaignPost,
  setCampaignPost,
  setActiveStep,
  contactGroup,
  setContactGroup,
  contactGroupName,
  contactsType,
}) => {
  const isAudienceLocked =
    typeof contactGroupName === "string" && contactGroupName.trim() !== "";

  if (!campaignPost.campaignName || !campaignPost.template) {
    return (
      <Alert severity="warning">
        Enter a campaign name and select a template before choosing an
        audience.
        <Button
          onClick={() => {
            setActiveStep(0);
          }}
          variant="outlined"
          sx={{ ml: 2 }}
        >
          Go back
        </Button>
      </Alert>
    );
  }
  const tabsData =
    isAudienceLocked
      ? [
          contactsType === "database"
            ? {
                label: "Marketing",
                icon: (
                  <HighlightIcon
                    fontSize="small"
                    sx={{ transition: "all 0.3s" }}
                  />
                ),
              }
            : {
                label: "Contact Group",
                icon: (
                  <ContactPhoneIcon
                    fontSize="small"
                    sx={{ transition: "all 0.3s" }}
                  />
                ),
              },
        ]
      : [
          {
            label: "Excel Import",
            icon: (
              <ImportExportIcon
                fontSize="small"
                sx={{ transition: "all 0.3s" }}
              />
            ),
          },
          {
            label: "Contact Group",
            icon: (
              <ContactPhoneIcon
                fontSize="small"
                sx={{ transition: "all 0.3s" }}
              />
            ),
          },
          {
            label: "Marketing",
            icon: (
              <HighlightIcon fontSize="small" sx={{ transition: "all 0.3s" }} />
            ),
          },
          {
            label: "Quick Contacts",
            icon: (
              <PhoneForwardedIcon
                fontSize="small"
                sx={{ transition: "all 0.3s" }}
              />
            ),
          },
        ];
  return (
    <Box>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h6" fontWeight={700}>
          Choose your target audience
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          Import contacts, select an existing group, or build a database
          audience.
        </Typography>
      </Box>
      <CustomTabs
        tabs={tabsData}
        value={isAudienceLocked ? 0 : contactGroup}
        onChange={(e, newValue) => {
          if (isAudienceLocked) return;

          setCampaignPost((prev) => {
            const campaign = { ...prev, contacts: [] };
            delete campaign.contactGroup;
            delete campaign.contactsList;
            delete campaign.contactMapping;
            delete campaign.headerMapping;
            delete campaign.isMarketing;
            delete campaign.marketingQuery;
            delete campaign.startIndex;
            delete campaign.endIndex;
            delete campaign.contactsCount;
            delete campaign.dataSplitsList;
            return campaign;
          });
          setContactGroup(newValue);
        }}
        containerSx={{
          width: "100%",
          my: 1,
          border: "1px solid",
          borderColor: "divider",
          boxShadow: "none",
        }}
      />
      {contactGroup === 0 && (
        <RdCampaignImport
          campaignPost={campaignPost}
          setCampaignPost={setCampaignPost}
          setActiveStep={setActiveStep}
          contactGroup={contactGroup}
        />
      )}
      {contactGroup === 1 && (
        <RdCampaignContactGoup
          campaignPost={campaignPost}
          setCampaignPost={setCampaignPost}
          setActiveStep={setActiveStep}
          contactGroup={contactGroup}
          groupName={contactGroupName}
        />
      )}
      {contactGroup === 2 && (
        <RdMarketingGroup
          campaignPost={campaignPost}
          setCampaignPost={setCampaignPost}
          setActiveStep={setActiveStep}
          contactGroup={contactGroup}
          groupName={contactGroupName}
        />
      )}
      {contactGroup === 3 && (
        <RdCampaignQuickContacts
          campaignPost={campaignPost}
          setCampaignPost={setCampaignPost}
          setActiveStep={setActiveStep}
          contactGroup={contactGroup}
        />
      )}
    </Box>
  );
};

export default RdCampaignStep2;
